<a [routerLink]="link" [routerLinkActive]="['active-border', 'border-yellow-500']" [routerLinkActiveOptions]="{exact: true}" class="flex after:bg-yellow-500 flex-col items-center justify-center text-white p-2 pb-1 nav-link">
  <i class="fas" [class]="icon"></i>
  <div class="text-xs">{{text}}</div>
</a>
